import { Keyboard } from 'lucide-react'
import type { LangCode } from '@/lib/baba-api'
import { LanguageSwitcherIcon } from '@/components/icons/baba-icons'
import { TranslatorLangPicker } from './TranslatorLangPicker'
import { WsButtonSecondary, WsIconButton } from './workspace'
import { HeaderPlan } from './HeaderPlan'

export interface ToolbarProps {
  sourceLang: LangCode
  targetLang: LangCode
  onSourceLangChange: (v: LangCode) => void
  onTargetLangChange: (v: LangCode) => void
  onSwap: () => void
  onOpenCommands: () => void
}

function Divider() {
  return <span aria-hidden className="shrink-0" style={{ width: 1, height: 22, background: 'var(--line)', margin: '0 4px' }} />
}

export function Toolbar({
  sourceLang,
  targetLang,
  onSourceLangChange,
  onTargetLangChange,
  onSwap,
  onOpenCommands,
}: ToolbarProps) {
  return (
    <div
      className="hidden md:flex shrink-0 items-center gap-2 h-[50px] px-3.5 border-b border-app"
      style={{ background: 'var(--cream-2)' }}
    >
      <TranslatorLangPicker value={sourceLang} onChange={onSourceLangChange} side="source" disabledCode={targetLang} width={124} />
      <WsIconButton
        icon={<LanguageSwitcherIcon size={15} />}
        label="Swap languages"
        onClick={onSwap}
        className="cursor-pointer"
      />
      <TranslatorLangPicker value={targetLang} onChange={onTargetLangChange} side="target" disabledCode={sourceLang} width={124} />

      <div className="flex-1" />

      <HeaderPlan />

      <Divider />

      <WsButtonSecondary icon={<Keyboard size={14} aria-hidden />} onClick={onOpenCommands}>
        Commands
      </WsButtonSecondary>
    </div>
  )
}
